import { playParamsFrag } from '@/service/fragments/playParamsFrag'
import type { ArtistFields } from '@/service/fragments/artistFieldsFrag'
import type { TrackFields } from '@/service/fragments/trackFieldsFrag'
import type { PlaylistFields } from '@/service/fragments/playlistFieldsFrag'
import type { StationFields } from '@/service/fragments/stationFieldsFrag'
import type { PodcastEpisodeFields } from '@/service/fragments/podcastEpisodeFieldsFrag'
import type { PodcastShowFields } from '@/service/fragments/podcastShowFieldsFrag'
import type { AlbumFields } from '@/service/fragments/albumFieldsFrag'
import type { AudiobookFields } from '@/service/fragments/audiobookFieldsFrag'
import { gql } from '@/service/gql'

/**
 * The union of entity shapes a `PlaylistEntry` can carry. Audiobook is
 * included so `select()` can route it to the Audible engine — but the schema's
 * `PlayableEntity` interface does NOT list Audiobook, so audiobook entries are
 * built from `audiobookFields` directly (see `audiobookToPlaylistEntry`) rather
 * than the `playableEntity` fragment below.
 */
export type PlayableEntity =
    | ArtistFields
    | AlbumFields
    | TrackFields
    | PlaylistFields
    | StationFields
    | PodcastEpisodeFields
    | PodcastShowFields
    | AudiobookFields

// TODO: add 'Advertisement' | 'Interlude'

// language=GraphQL
export const playableEntityFrag = gql(
    `
        fragment playableEntity on PlayableEntity @_unmask {
            __typename
            uri @include(if: $isAuthenticated)
            playParams {
                ...playParams
            }
        }
    `,
    [playParamsFrag]
)
